export default {"src":"/_next/static/media/bnb.a19c504b.svg","height":46,"width":100,"blurWidth":0,"blurHeight":0};